import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../provide/auth.service';
import { CommonService } from '../provide/common.service';

@Injectable({
  providedIn: 'root'
})
export class BeforeLoginGuard  {
  constructor(private router: Router, private commonService: CommonService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.commonService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/home'])
      return false;
    }
  }
}

